import CreatePassword from "./CreatePassword";
import { PASSWORD_MOD_TYPE } from "../../common/constants/token";

export default function ForgotPassword() {
  return <CreatePassword type={PASSWORD_MOD_TYPE.FORGOT} />;
}
